import { BuilderBaseValidationSummaryModel } from "./builder-base-validation-summary.model";

export class BuilderActionValidationSummaryModel extends BuilderBaseValidationSummaryModel {
    actionRules: any[] = [];
    actions: string[] = [];
    allowsMoreActions: boolean = false;
    blockedActions: string[] = [];
    documents: any[] = [];
    persons: any[] = [];
    possibleActions: string[] = [];
    request: any = {};
}